import { render, staticRenderFns } from "./ProtocolDetailBox.vue?vue&type=template&id=9cfdd0c2&scoped=true"
import script from "./ProtocolDetailBox.vue?vue&type=script&lang=js"
export * from "./ProtocolDetailBox.vue?vue&type=script&lang=js"
import style0 from "./ProtocolDetailBox.vue?vue&type=style&index=0&id=9cfdd0c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cfdd0c2",
  null
  
)

export default component.exports